module.exports = __webpack_public_path__ + "static/media/logo_light_wonder.51a24efa.svg";